<template>
    <v-container fluid>
        <v-row
            class="mx-0"            
        >
            <v-col
                class="title mt-2"
                cols="8"
            >
                Event Log
            </v-col>
        </v-row>
        <v-row
            class="mx-0" 
        >
            <v-col>
                <v-data-table
                    id="eventLogTable"
                    fixed-header
                    :headers="headers"
                    :options.sync="paginationOptions"
                    :loading="loading"
                    :server-items-length="recordCount"
                    :items="events"
                    style="white-space: nowrap;"
                    loading-text="Loading... Please wait"                   
                    :page.sync="page"
                    :footer-props="{
                        'items-per-page-options': perPageChoices
                    }"
                >
                    <template v-slot:[`item.account`]="{item}">
                        {{ item.account }}
                    </template>
                    <template v-slot:[`item.created`]="{item}">
                        {{ formatDate(item.created) }}
                    </template>
                </v-data-table>
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
import webtmsBackend from '@/services/webtmsBackend';
import moment from 'moment';
import { guidEqual } from '@/utils/guid.js';

export default {  
    data: () => ({
        headers: [
            {text: 'Account', value: 'account', sortable: false},
            {text: 'Created', value: 'created', sortable: false},
            {text: 'Description', value: 'description', sortable: false}
        ],
        events: [],
        LocatorLogix: 'Locator LOGiX', 
        loading: false,
        paginationOptions: {
            itemsPerPage: 15
        },
        page: 1,
        pageCount: 0,
        recordCount: 0,
        rowStart: 1,
        perPageChoices: [10,15,20,50,100,500],
            
    }),
    computed: {
        companyId() {
            return this.$store.getters.company.cid;
        }
    },
    watch: {
        paginationOptions: {
            handler () {
                this.getEvents();
            },
            deep: true,
        },
    },
    mounted() {
            
    },
    methods: {   
        async getEvents() {
            const { itemsPerPage } = this.paginationOptions;
            this.events = [];            
            this.loading = true;
            let response = await webtmsBackend.getEvents(this.CompanyId, this.page, itemsPerPage);
            this.loading = false;
            for(let m of response.data) {           
                this.events.push({
                    account: this.getUser(m.uid),
                    created: m.created,
                    description: m.description,
                }); 
            } 
            if (response.recordCount) {
                this.recordCount = response.recordCount;
            }          

        },
        getUser(uid) {
            let user = this.$store.getters.companyUsers.find(u => guidEqual(u.uid, uid));
            return user ? user.name : ''; // this.LocatorLogix';
        },     
        formatDate(date) {
            return moment(date).format('MM/DD/YYYY, h:mm A');            
        },
    },
}
;
</script>
<style>
 #eventLogTable thead,
    #eventLogTable th {
        background-color: var(--ll-surface-subtle);
    }
    #eventLogTable td {
        background: var(--ll-surface);
    }
    .title {
        font-size: 20px;
    }
    .company {
        font-size: 16px;
        font-weight: 500;
    }   
</style>
